import { j as r } from "../../../../../../../../../../../../jsx-runtime.BREq8dyb.js";
import { faCircle as e } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as n } from "@fortawesome/react-fontawesome";
import { Box as s } from "@mui/joy";
import { memo as m } from "react";
const a = m(({
  color: t = "inherit",
  value: i,
  sx: o
}) => i ? /* @__PURE__ */ r.jsxs(s, { sx: {
  alignItems: "center",
  color: t,
  display: "flex",
  gap: "0.125rem",
  transition: "all 0.2s ease-in-out",
  ...o
}, children: [
  /* @__PURE__ */ r.jsx("span", { children: JSON.stringify(i) }),
  /* @__PURE__ */ r.jsx(n, { fixedWidth: !0, icon: e, style: {
    fontSize: "0.5rem"
  } })
] }) : null);
a.displayName = "Indicator";
export {
  a as default
};
//# sourceMappingURL=Indicator.js.map
